import React, {Component} from 'react';
import {FormattedMessage} from 'react-intl';


class DefaultContentJoyride extends Component {

    render() {
        const {tourTitle, stepTitle, lineIds, styles, step} = this.props;

        return <div className="joyride-step-content-wrapper">
            {tourTitle && <div className="joyride-step-content-tour-title">
                <FormattedMessage id={tourTitle}/>
            </div>}
            {stepTitle && <div className="joyride-step-content-text-title">
                <FormattedMessage id={stepTitle}/>
            </div>}
            {lineIds.map((id, index) => {
                if (id === 'newLine') {
                    return <br key={id + index}/>
                } else {
                    return <div key={id + index} className="joyride-step-content-text" style={styles && styles[id] ? styles[id] : null}>
                        <FormattedMessage id={id}/>
                    </div>
                }
            })}
            {step && <div className="joyride-step-content-step">
                {step}
            </div>}
        </div>
    }
}

export default DefaultContentJoyride;